<template>
  <router-view/>

  <MessageBox v-if="messageBoxModelOpenClose" @close-modal="openMessageBoxModel(false)" :message="message.text"/>
  <OverlayLoading v-if="isLoading"></OverlayLoading>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue"
import {useStore} from "vuex"
import router from "@/router"
import axios from "@/composables/Axios"
import MessageBox from '@/components/modal/MessageBox'
import OverlayLoading from "@/components/modal/OverlayLoading";

const store = useStore(),
    isSign = computed(() => store.state.sign.isSign),
    message = computed(() => store.state.message),
    isLoading = computed(() => store.state.isLoading);

axios.$useAxios(store);

const messageBoxModelOpenClose = ref(false),
    openMessageBoxModel = (openClose) => messageBoxModelOpenClose.value = openClose;

watch(
    () => store.getters['sign/getSign'],
    (after, _) => after ? router.push('/') : router.push('sign')
)

watch(
    () => store.getters['getMessage'],
    () => openMessageBoxModel(true)
)

onMounted(() => {
  isSign.value ? router.push('/') : router.push('sign');
})

</script>

<style>
html, body {
  position: fixed;
  overflow: hidden !important;
  --bs-body-font-family: Pretendard, Arial, sans-serif;
}

#app {
  width: 100vw;
  height: 100vh;
}
</style>
